angular.module("qbePortal").controller("BikeFormController", [
	"$rootScope",
	"$scope",
	"$state",
	"$stateParams",
	"$window",
	"userInputRepository",
	"serviceResponseRepository",
	"quoteOptions",
	"paymentService",
	"quoteModelFactory",
	"dynamicRouter",
	"portalServiceWrapper",
	"MAService",
	"labelService",
	"Util",
	"$q",
	"storage",
	"gtmService",
	"quoteRequestRepository",
	"tokenTimeoutService",
	"$compile",
	"smartLinkService",
	"campaignService",
	function (
		$rootScope,
		$scope,
		$state,
		$stateParams,
		$window,
		userInputRepository,
		serviceResponseRepository,
		quoteOptions,
		paymentService,
		quoteModelFactory,
		dynamicRouter,
		portalServiceWrapper,
		MAService,
		labelService,
		util,
		$q,
		storage,
		gtmService,
		quoteRequestRepository,
		tokenTimeoutService,
		$compile,
		smartLinkService,
		campaignService
	) {
		var $ctrl = this;

		//check if session function is embedded and append directive
		if ($window.qbe.fieldLabels != undefined) {
			if (angular.isObject($window.qbe.fieldLabels.sessionFunction))
				angular
					.element("div#phglobaloptions_0_divOptionsComponents")
					.after($compile("<div qb-ng-dialog></div>")($scope));
		}

		/**
		 * routing initialisation, enabling/disabling (hiding/showing) available routes
		 * testing for allowed routes and redirecting when not allowed
		 */
		function initialiseRouting() {
			storage.removeItem("policy-date-input");

			var stepConditions = {
				"bike.payment": function () {
					return $state.$current.name != "bike.done";
				},
				"bike.done": function () {
					return $state.$current.name == "bike.done";
				},
				"bike.policy-start-date": function () {
					return $state.$current.name == "bike.policy-start-date";
				},
			};
			dynamicRouter.initialise(
				$state.current.name,
				$state.$current.parent.name,
				stepConditions,
				markCompletedRouteCallback
			);
			$ctrl.title = dynamicRouter.getPageTitle();
			$ctrl.steps = dynamicRouter.getSteps();
		}

		function markCompletedRouteCallback(stateName) {
			storage.setItem("completed-step", stateName);
		}
		/** End of routing logic */

		$rootScope.$broadcast("loading-animation-end");
		$ctrl.elementName = "Form Controller";
		$ctrl.validationErrors = null;
		$ctrl.sections = {};
		$ctrl.state = $state;
		$ctrl.storage = storage;
		$ctrl.sideBarEmail = null;
		$ctrl.quoteModel = quoteModelFactory.create();
		$ctrl.saveOnExit = false;
		$ctrl.smartLink = null;

		$window.onbeforeunload = function (event) {
			exitSaveQuote();
			if ($ctrl.saveOnExit) {
				$rootScope.$digest();
				return "Are you sure you want to leave?";
			}
		};

		$scope.$on("session-save-quote", exitSaveQuote);

		function exitSaveQuote() {
			var emailAddress = angular
				.element("div")
				.find("[label-key=yourEmailAddress]")
				.val();

			if (dynamicRouter.getPageTitle() != "Payment") {
				if (
					$ctrl.quoteModel.email != null ||
					$ctrl.sideBarEmail != null ||
					emailAddress != ""
				) {
					if ($ctrl.quoteModel && $ctrl.quoteModel.quoteResult) {
						$ctrl.saveOnExit = true;
						var formData = getUserInput();
						var paymentFrequency = "everyyear";

						portalServiceWrapper.updateQuote(formData);

						portalServiceWrapper
							.saveQuote(paymentFrequency, {
								quote: "true",
							})
							.then(function () {
								$rootScope.$broadcast("session-redirect");
							})
							.catch(function () {
								$rootScope.$broadcast("session-redirect");
							});
					} else {
						$rootScope.$broadcast("session-redirect");
					}
				} else $rootScope.$broadcast("session-redirect");
			}
		}

		function getDefaultValues() {
			return {
				fromFullQuote: true,
				bikeForm: {
					getStarted: {
						policyStartDate: moment()
							.tz("Australia/Sydney")
							.format("DD/MM/YYYY"),
						personOrCompany: "person",
					},
					insuredExcessValue: {
						thirdPartyOrThirdPartyFireAndTheft: "standard",
						comprehensivePref: "market",
						voluntaryMotorcycleExcess: 0,
						excess: 0,
						flexiExcess: 0,
					},
				},
				paymentForm: {
					paymentDetails: {
						paymentOptions: "yearly",
					},
				},
			};
		}

		/**
		 * QbFormSections register themselves with the form controller.
		 * This is done automatically by the form section upon initialisation.
		 * @name : name of the form section
		 * @init : function callback initialise the section
		 * @getValueFn: function callback to get the value of the section.
		 */
		$ctrl.registerSection = function (name, init, getValueFn) {
			$ctrl.sections[name] = {
				initValue: init,
				getValue: getValueFn,
			};
		};

		/**
		 * Any generic breaking errors should broadcast 'error' to the rootScope. This will cause redirection
		 * to the main error page.
		 */
		$scope.$on("error", function (event, error) {
			$state.go("error", error);
		});

		/**
		 * calls MA Services to add marketing data.
		 */
		$scope.$on("perform-ma-service", function (event, triggeredBy) {
			performMAServices(triggeredBy);
		});

		$scope.$on("back", function () {
			gtmService.trackEvent("back");
			$ctrl.back();
		});

		$scope.$on("invalidate-quotes", invalidatePreviousQuote);

		function invalidatePreviousQuote() {
			serviceResponseRepository.update("quote", null);
			quoteRequestRepository.clearQuoteCredentials();
			storage.removeItem("policy-address");
		}

		/**
		 * message broadcasted by qbPaymentSummary to submit the form
		 */
		//hadles form submit from child elements
		$scope.$on("form-submit", function (event, formName) {
			$ctrl.submit($scope[formName]);
		});

		/**
		 * message broadcasted by qbPaymentSummary to save the form
		 */
		$scope.$on("sidebar-save-quote", function (event, data) {
			$ctrl.sideBarEmail = data;
			$ctrl.save();
		});

		/**
		 * message broadcasted by qbPaymentSummary to assign the email address
		 */
		 $scope.$on("sidebar-assign-mail", function (event, data) {
			if (data != "") $ctrl.sideBarEmail = data;
		});

		function requote(form) {
			var isValid = !form || form.$valid;
			var formData = getUserInput();
			
			if (isValid) {								
				gtmService.trackEvent("requote");
				$rootScope.$broadcast("loading-animation-start");
				getRequote(formData, null, function (resp) {
					$scope.$broadcast("reset-field-errors");
					$rootScope.$broadcast("loading-animation-end");
					$rootScope.$broadcast("quote-received", resp);
					$rootScope.$broadcast("selected-quote-changed");
				});
			} else {
				displayFormErrors();
			}
		}
		/**
		 * called from qbFormSection and any other panel that requires a requote based on new values.
		 */
		$scope.$on("requote", function (event, form) {			
			requote(form);
		});

		/**
		 * message broadcasted by qbFormSection.directive to move to a page
		 */
		$scope.$on("moveToPage", function (event, page) {
			$ctrl.moveToPage(page);
		});

		function prepopulateRetrievedQuote() {
			if ($stateParams.quoteNo && $stateParams.email) {
				gtmService.trackEvent("retrieve-quote");
				$rootScope.$broadcast("loading-animation-start");
				portalServiceWrapper
					.retrieveSavedQuote(
						$stateParams.quoteNo,
						$stateParams.email
					)
					.then(function (transformedQuote) {
						$q.all([
							portalServiceWrapper.refreshAddress(
								transformedQuote.address
							),
							portalServiceWrapper.refreshVehicleDetails(
								transformedQuote.motorcycleInfo.vgiId,
								storage.getItem('policy-start-date'))
						]).then(function (resps) {
							var bikeFormData = ($ctrl.formData.bikeForm = transformedQuote);
							var serviceResponse = storage.getItem(
								"service-response"
							);

							storage.setItem(
								"policy-address",
								serviceResponse.quote.policyAddress
							);

							if (!bikeFormData.aboutYourBike)
								bikeFormData.aboutYourBike = {};
							bikeFormData.aboutYourBike.address = resps[0].data;
							userInputRepository.update($ctrl.formData);
							storage.setItem("retrieve", true);
							if (
								moment()
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD") >
								moment(serviceResponse.quote.periodStartDate)
									.tz("Australia/Sydney")
									.format("YYYY/MM/DD")
							) {
								storage.setItem(
									"policy-date-input",
									$ctrl.formData
								);
								$state.go(
									"bike.policy-start-date",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							} else {
								$state.go(
									"bike.bike",
									{
										quoteNo: "",
										email: "",
									},
									{
										location: true,
										reload: true,
									}
								);
							}
						});
					})
					.catch(function () {
						var expiredQuote = storage.getItem("expired-quote");
						if (expiredQuote.displayStatus == "Expired") {
							storage.removeItem("expired-quote");
							window.location.href = util.linkBuilder(
								window.qbe.fieldLabels.expiredQuoteRedirect
									.bikeExpired
							);
						}
					});
			}
		}

		function applyPromoCodeThroughLink() {
			if ($stateParams.promotionalCode) {
				var formData = $ctrl.formData;
				if (formData.bikeForm) {
					if (!formData.bikeForm.tellUsABitMore) {
						formData.bikeForm.tellUsABitMore = {};
					}
					formData.bikeForm.tellUsABitMore.promotionalCode =
						$stateParams.promotionalCode;
				}
			}
		}

		function getUserInput() {
			var formData = getFormInput();
			if (formData.bikeForm && formData.bikeForm.insuredExcessValue) {
				if (formData.bikeForm.insuredExcessValue.excess > 0) {
					formData.bikeForm.insuredExcessValue.flexiExcess = 
					formData.bikeForm.insuredExcessValue.excess - $ctrl.quoteModel.excess.standardExcess;
				}					
			}
			userInputRepository.update(formData);
			return userInputRepository.get(getDefaultValues());
		}

		function getFormInput() {
			var formData = {};
			for (var key in $ctrl.sections) {
				formData[key] = $ctrl.sections[key].getValue();
			}

			if ($ctrl.sideBarEmail != null) {
				if (
					formData.bikeForm.tellUsABitMore &&
					formData.bikeForm.tellUsABitMore.yourEmailAddress
				)
					formData.bikeForm.tellUsABitMore.yourEmailAddress =
						$ctrl.sideBarEmail;
				if (
					formData.bikeForm.mainPolicyHolderContact &&
					formData.bikeForm.mainPolicyHolderContact.emailAddress1
				)
					formData.bikeForm.mainPolicyHolderContact.emailAddress1 =
						$ctrl.sideBarEmail;
			}

			return formData;
		}

		function displayFormErrors() {
			$scope.$broadcast("broadcast-field-errors");
			$ctrl.showErrorSummary = true;
			$scope.$broadcast("reset-field-errors");
			scrollViewTo($("#combinedValidationListing"));
		}

		$ctrl.submit = function (form) {
			$scope.$broadcast("form-submitted");
			$ctrl.showErrorSummary = false;
			isInvalid = form.$invalid;
			if (isInvalid) {
				displayFormErrors();
				return;
			}

			gtmService.trackEvent("next");

			setDefaultContactValuesIfRequired();

			$rootScope.$broadcast("loading-animation-start");

			var formData = getUserInput();
			
			//send quote to decline when isRegistered is NO
			if (formData.bikeForm.aboutYourBike.isRegistered === false) {
				//decline quote
				performMAServices("declined");
				storage.clear();
				redirectToDecline("decline", "Policy Was Declined");
				return;
			}

			var quickQuote = getQuickQuote(formData, function (resp) {
				$ctrl.quoteModel = quoteModelFactory.create();				
				var regoSearchDetails = serviceResponseRepository.getLastResponseFrom('regoSearch');
				if (regoSearchDetails && regoSearchDetails.goodRetailPrice === '0') {
					var quickQuoteResultList = resp.data;
					if (quickQuoteResultList && quickQuoteResultList.length > 0) {
						var quickQuoteResult = quickQuoteResultList[0];
						var motorcycles = quickQuoteResult.motorcycles;					
						if (motorcycles && motorcycles.length > 0) {
							//update goodRetailPrice when quickquote provided sumInsuredAmount
							regoSearchDetails.goodRetailPrice = motorcycles[0].sumInsuredAmount;
							serviceResponseRepository.update('regoSearch', regoSearchDetails);
						}
					}					
				}
				$rootScope.$broadcast("perform-ma-service", "next");
				proceedToNextStep(formData);
			});

			if (!quickQuote) {
				proceedToNextStep(formData);
			}
		};

		function setDefaultContactValuesIfRequired(formData) {
			var contactValuesRequired = ["bike.contact"];
			var testRequired =
				contactValuesRequired.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				setDefaultContactValues();
			}
		}

		function testDeclineIfRequired(formData) {
			var declineTestRequiredFor = [
				"bike.riders",
				"bike.bike",
				"bike.quote",
			];
			var testRequired =
				declineTestRequiredFor.indexOf($state.$current.name) >= 0;
			if (testRequired) {
				testDecline(formData);
			}
		}

		function testDecline(formData) {
			portalServiceWrapper.updateQuote(formData);

			var declineQuoteOptions = quoteOptions.getTestQuoteDeclineOptions(
				$state.$current.name
			);
			//test quote decline and then check embargo
			var postcode = formData.bikeForm.aboutYourBike.address.postalCode;
			portalServiceWrapper.checkEmbargo(postcode, 'Bike')
			.then(function(resp) {
				if (resp) {
					//it is embargo
					performMAServices("declined");
					storage.clear();	
					var declineObj = {declineType: 'embargo'};
					redirectToDecline(declineObj, "Policy Was Declined");
				}
				else {
					portalServiceWrapper
					.testQuoteDecline(declineQuoteOptions)
					.catch(function (decline) {
						performMAServices("declined");
						storage.clear();
						redirectToDecline(decline, "Policy Was Declined");
					});	
				}
			});								
		}

		function redirectToDecline(decline) {
			var redirectPage = decline.declineType || "decline";
			$state.go(redirectPage, decline);
		}

		function saveQuoteIfRequired(formData) {
			saveQuoteNotRequiredFor = ["bike.bike", "bike.done"];
			var notRequired =
				saveQuoteNotRequiredFor.indexOf($state.$current.name) >= 0;
			if (!notRequired) {
				saveQuote(formData);
			}
		}

		function triggerGoalCompleteQuoteIfRequired() {
			if ($state.$current.name == "bike.done") {
				var userInputFromRepo = quoteRequestRepository.getUserInput();
				if (!userInputFromRepo || !userInputFromRepo.email) {
					var formData = getUserInput();
					quoteRequestRepository.update(formData);
				}				
				portalServiceWrapper.triggerGoalCompleteQuote();
			}
		}

		function getRequote(formData, page, callback) {
			portalServiceWrapper.updateQuote(formData);
			var requoteOptions =
				page == "payment"
					? quoteOptions.getRequoteOptions("bike.payment")
					: quoteOptions.getRequoteOptions();
			if (requoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						requoteOptions.permutations,
						requoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						console.log(err);
						broadcastError(err, "Requote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function getQuickQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);
			var quickQuoteOptions = quoteOptions.getQuickQuoteOptionsForStep(
				$state.current.name
			);
			if (quickQuoteOptions) {
				portalServiceWrapper
					.getQuickQuote(
						quickQuoteOptions.permutations,
						quickQuoteOptions.rules
					)
					.then(function (resp) {
						if (callback) callback(resp);
					})
					.catch(function (err) {
						broadcastError(err, "getQuickQuote error");
					});
			} else {
				return false;
			}
			return true;
		}

		function broadcastError(err, msg) {
			$rootScope.$broadcast("error", {
				errorMessage: msg,
				response: err,
			});
		}

		function saveQuote(formData, callback) {
			portalServiceWrapper.updateQuote(formData);

			var paymentFrequency = quoteOptions.getSelectedPaymentFrequencyForService();

			portalServiceWrapper
				.saveQuote(paymentFrequency)
				.then(function (resp) {
					if (callback) callback(resp);
					// If quoteId found and email found, triggerGoal service quote
					var qr = quoteRequestRepository.getSaveQuoteRequest(paymentFrequency);
					console.log('bikeForm.Control_saveQuote qr', qr);
					if (qr && qr.quoteID && qr.email) {
						portalServiceWrapper.triggerGoalSaveQuote();
					}
					return resp;
				})
				.catch(function (err) {
					if (tokenTimeoutService.isSessionTimedout()) {
						tokenTimeoutService.handleTimeout();
					} else {
						broadcastError(err, "Save quote error");
					}
					return err;
				});
		}

		function proceedToNextStep(formData) {
			$rootScope.$broadcast("loading-animation-start");
			saveQuoteIfRequired(formData);
			testDeclineIfRequired(formData);
			$state.go(dynamicRouter.next(markCompletedRouteCallback));
		}

		function performMAServices(eventName) {
			getUserInput();
			var mainPolicyHolder = userInputRepository.get(
				{},
				"bikeForm.mainPolicyHolder"
			);
			var policyEmail = userInputRepository.get({}, "email");
			var quoteResult = quoteOptions.getSelectedQuoteResult();
			var savedQuote = serviceResponseRepository.getLastResponseFrom(
				"quote"
			);
			var quoteModel = $ctrl.quoteModel;
			var maData = {
				state: quoteModel ? quoteModel.state : null,
				postCode: quoteModel ? quoteModel.postCode : null,
				campaignCode: quoteModel ? quoteModel.campaignCode : null,
				noClaimBonus: quoteModel ? quoteModel.noClaimBonus : null,
				pageName: $state.current.name,
				mainPolicyHolder: mainPolicyHolder,
				policyEmail: policyEmail,
				annualResult: quoteResult ? quoteResult.getAnnual() : null,
				monthlyResult: quoteResult ? quoteResult.getMonthly() : null,
				quoteId: savedQuote ? savedQuote.quoteID : null,
			};

			if ($state.current.name == "bike.done") {
				maData.inceptionDate = moment()
					.tz("Australia/Sydney")
					.format("DD/MM/YYYY");
			}

			if (
				quoteModel &&
				quoteModel.address &&
				quoteModel.address.addressLine1
			) {
				maData.address =
					quoteModel.address.addressLine1 +
					" " +
					quoteModel.address.city;
			}

			if (
				quoteModel &&
				quoteModel.gtmPolicyHolder &&
				quoteModel.gtmPolicyHolder.phoneNumber
			) {
				maData.contactNumber = quoteModel.gtmPolicyHolder.phoneNumber;
			}

			MAService.mergeContacts(eventName, maData);
		}

		// Payments

		/**
		 * Scrolls a field into view when an error is clicked
		 * @param {Object} error                    Error object with key `name`
		 */
		$ctrl.showInView = function (error) {
			//console.log(error);
			scrollViewTo($('[name="' + error.name + '"]'));
		};

		function scrollViewTo($element) {
			var offset = $element.offset();
			if (offset) {
				$("html, body").animate({
					scrollTop: offset.top - 50,
					scrollLeft: offset.left,
				});
			}
		}

		/**
		 * determines if a quote is available to enable save button.
		 */
		$ctrl.isSaveButtonEnabled = function () {
			var formData = getUserInput();
			return formData.rapidEstimateUrl != null;
		};

		$ctrl.isQuoteAvailable = function () {
			return quoteOptions.getSelectedQuoteResult() !== null;
		};

		/**
		 * Takes care of
		 * - registering the labels generated by sitecore
		 * - setting default values
		 * - prepopulating retrieve quote if required.
		 */
		$ctrl.initPage = function () {
			initialiseRouting();

			util.dispatchCustomEvent("register-labels");
			$ctrl.formData = getUserInput();
			overwritePromoCodeFromQueryString();
			var currentPageName = $ctrl.state.current.name;
			$ctrl.displayBack =
				$ctrl.formData.rapidEstimateUrl != null ||
				currentPageName != "bike.bike";
			if (
				$ctrl.formData.rapidEstimateUrl &&
				currentPageName === "bike.bike"
			) {
				invalidatePreviousQuote();
			}
			triggerGoalCompleteQuoteIfRequired();
			prepopulateRetrievedQuote();
			applyPromoCodeThroughLink();
		};

		function overwritePromoCodeFromQueryString() {
			var promoCode = util.getQueryStringByName(
				window.location,
				"promotionalCode"
			);
			if (promoCode) {
				$ctrl.formData.promotionalCode =
					$ctrl.formData.promotionalCode || {};
				$ctrl.formData.promotionalCode.promotionalCode = promoCode;
			}
		}

		$ctrl.initQuotePage = function () {
			$ctrl.initPage();
			var selectedCoverType = quoteOptions.getSelectedCoverType();
			var formData = getUserInput(),
				form = formData.bikeForm;

			// getRequote(formData);
			$scope.$broadcast("requote");

			if (!form.insuredExcessValue) form.insuredExcessValue = {};

			form.saveOnPremium = form.saveOnPremium || {};
			form.saveOnPremium.saveOnYourPremium = selectedCoverType.subType;

			if (selectedCoverType.superType == "third_party")
				form.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft =
					selectedCoverType.subType;

			$ctrl.formData.bikeForm = form;
		};

		$ctrl.initContact = function () {
			$ctrl.initPage();
			setDefaultContactValues();
		};

		function setDefaultContactValues() {
			var formData = getUserInput(),
				form = formData.bikeForm,
				postalAddress = storage.getItem("policy-address");

			if (form.getStarted.personOrCompany === "person") {
				form.mainPolicyHolder = form.mainPolicyHolder || {};
				if (
					form.mainPolicyHolder.isMainRiderMainPolicyHolder !== false
				) {
					form.mainPolicyHolder.isMainRiderMainPolicyHolder = true;
					form.mainPolicyHolder.title =
						form.mainPolicyHolder.title ||
						form.rider.riders[0].person.title;
					form.mainPolicyHolder.firstName =
						form.rider.riders[0].person.firstName;
					form.mainPolicyHolder.lastName =
						form.rider.riders[0].person.lastName;
					form.mainPolicyHolder.gender =
						form.rider.riders[0].person.gender;
					form.mainPolicyHolder.dateOfBirth =
						form.rider.riders[0].person.dateOfBirth;

					form.mainPolicyHolder.threeYears_restrictedSuspendedDisqualifiedCancelled =
						form.rider.riders[0].threeYears_restrictedSuspendedDisqualifiedCancelled;
					form.mainPolicyHolder.threeYears_restrictedSuspendedDisqualifiedCancelledDetails =
						form.rider.riders[0].threeYears_restrictedSuspendedDisqualifiedCancelledDetails;

					form.mainPolicyHolder.threeYears_accidentsClaims =
						form.rider.riders[0].threeYears_accidentsClaims;
					form.mainPolicyHolder.threeYears_accidentsClaimsDetails =
						form.rider.riders[0].threeYears_accidentsClaimsDetails;

					form.mainPolicyHolder.fiveYears_chargedOrConvicted =
						form.rider.riders[0].fiveYears_chargedOrConvicted;
					form.mainPolicyHolder.fiveYears_chargedOrConvictedDetails =
						form.rider.riders[0].fiveYears_chargedOrConvictedDetails;

					form.mainPolicyHolderContact =
						form.mainPolicyHolderContact || {};
					form.mainPolicyHolderContact.postalOption =
						form.mainPolicyHolderContact.postalOption || true;
					form.mainPolicyHolderContact.emailAddress1 =
						form.mainPolicyHolderContact.emailAddress1 ||
						formData.email;
					form.mainPolicyHolderContact.primaryPhone =
						form.mainPolicyHolderContact.primaryPhone || "mobile";
				}

				if (
					!!form.mainPolicyHolderContact &&
					!form.mainPolicyHolderContact.address
				) {
					form.mainPolicyHolderContact.address =
						form.aboutYourBike.address;
				}

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.mainPolicyHolderContact.address.addressLine1 &&
						postalAddress.postalCode !==
							form.mainPolicyHolderContact.address.postalCode
					) {
						form.mainPolicyHolderContact.postalOption = false;
						form.mainPolicyHolderContact.postalAddress = postalAddress;
					}
				}
			}

			if (form.getStarted.personOrCompany === "company") {
				form.aboutCompany = form.aboutCompany || {};
				form.aboutCompany.name = form.aboutCompany.name || "";
				form.aboutCompany.abn = form.aboutCompany.abn || "";
				form.aboutCompany.email = form.aboutCompany.email || "";
				form.aboutCompany.officePhone =
					form.aboutCompany.officePhone || "";
				form.aboutCompany.companyAddress =
					form.aboutCompany.companyAddress || undefined;

				form.companyContact = form.companyContact || {};
				form.companyContact.postalOption =
					form.companyContact.companyContactDetailsPostalOption ||
					true;
				form.companyContact.companyContactTitle =
					util.capitalize(form.companyContact.companyContactTitle) ||
					form.rider.riders[0].person.title;
				form.companyContact.companyContactFirstName =
					form.companyContact.companyContactFirstName ||
					form.rider.riders[0].person.firstName;
				form.companyContact.companyContactLastName =
					form.companyContact.companyContactLastName ||
					form.rider.riders[0].person.lastName;
				form.companyContact.companyContactGender =
					parseGender(form.companyContact.companyContactGender) ||
					form.rider.riders[0].person.gender;
				form.companyContact.companyContactDateOfBirth =
					form.companyContact.companyContactDateOfBirth ||
					form.rider.riders[0].person.dateOfBirth;
				form.companyContact.companyContactDetailsAddress =
					form.companyContact.companyContactDetailsAddress ||
					form.aboutYourBike.address;
				form.companyContact.companyContactDetailsEmail =
					form.companyContact.companyContactDetailsEmail ||
					formData.email;
				form.companyContact.companyContactDetailsPostalAddress =
					form.companyContact.companyContactDetailsPostalAddress ||
					undefined;
				form.companyContact.primaryPhone =
					form.companyContact.primaryPhone || "mobile";
				form.companyContact.preferredNumber =
					form.companyContact.preferredNumber || "";
				form.companyContact.passwordQuestion = !!form.companyContact
					.enterAQuestion
					? "customerCreatedQuestion"
					: "" || "";
				form.companyContact.enterAQuestion =
					form.companyContact.enterAQuestion || "";
				form.companyContact.passwordAnswer =
					form.companyContact.passwordAnswer || "";

				if (Object.keys(postalAddress).length > 0) {
					if (
						postalAddress.addressLine1 !==
							form.companyContact.companyContactDetailsAddress
								.addressLine1 &&
						postalAddress.postalCode !==
							form.companyContact.companyContactDetailsAddress
								.postalCode
					) {
						form.companyContact.postalOption = false;
					}
				}
			}

			$ctrl.formData.bikeForm = form;
		}

		function parseGender(gender) {
			if (gender === "F") {
				return "female";
			} else if (gender === "I") {
				return "intersex";
			} else return "male";
		}

		function constructDonePageViewModel() {
			var done = {
				policyNumber: $stateParams.policyNumber,
				accountNumber: $stateParams.accountNumber,
				isAwaitingProcess: $stateParams.isAwaitingProcess,
				policyType: quoteOptions.getSelectedCoverType().label,
				policyStartDate: $ctrl.quoteModel.policyStartDate,
				showYearMakeModelInSummary: false,
				smartLinkURL: $window.qbe.fieldLabels.smartLink.url,
				hashKey: $window.qbe.fieldLabels.smartLink.hashKey,
				email: $ctrl.quoteModel.email,
				description: "Motorcycle Insurance",
				productRefs: "Motorcycle Insurance",
			};

			var regoNumber = $ctrl.quoteModel.regoNumber || "";
			if (
				$ctrl.quoteModel.bikeForm.tellUsYourRegoNumber &&
				$ctrl.quoteModel.bikeForm.tellUsYourRegoNumber.regoNumber
			) {
				done.showYearMakeModelInSummary = true;
			}

			done.regoNumber = regoNumber.toUpperCase();

			if ($ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails) {
				var year =
						$ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails
							.modelYear,
					make =
						$ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails
							.make,
					model =
						$ctrl.quoteModel.bikeForm.aboutYourBike.regoDetails
							.model;

				done.yearMakeModel = year + " " + make + " " + model;
			}

			if ($ctrl.quoteModel.bikeForm.mainPolicyHolder) {
				done.policyHolderName =
					$ctrl.quoteModel.bikeForm.mainPolicyHolder.firstName +
					" " +
					$ctrl.quoteModel.bikeForm.mainPolicyHolder.lastName;
			} else if ($ctrl.quoteModel.bikeForm.companyContact) {
				done.policyHolderName =
					$ctrl.quoteModel.bikeForm.companyContact.firstName +
					" " +
					$ctrl.quoteModel.bikeForm.companyContact.lastName;
				done.email = $ctrl.quoteModel.bikeForm.companyContact.email;
			}

			done.purchaseDate = moment()
				.tz("Australia/Sydney")
				.format("DD/MM/YYYY");
			return done;
		}

		$ctrl.initDonePage = function () {
			$ctrl.initPage();

			var quoteModel = $ctrl.quoteModel;
			var done = storage.getItem("done");
			if (!done || !done.policyNumber) {
				done = constructDonePageViewModel();
				$ctrl.smartLink = smartLinkService.generateLink(done);
				gtmService.trackTransaction(
					$state.current,
					done,
					$ctrl.quoteModel
				);
				performMAServices("paid");
			}

			$ctrl.storage.clear();
			storage.setItem("done", done);
			var $columns = $(".columns").get(0);
			$columns.classList.remove("print-ready");
			$ctrl.done = done;
			$ctrl.done.campaignSteps = {};

			// check if campaign code is valid
			if (
				quoteModel.quoteResult.response.isCampaignCodeValid ||
				quoteModel.quoteResult.response.isGiftCardApplied
			) {
				// get campaign next steps
				$ctrl.done.campaignSteps = campaignService.getCampaignConfig(
					quoteModel.quoteResult.response.campaignCode,
					true
				);
			} else $ctrl.done.campaignSteps.isCampaignCodeValid = false;
		};

		$scope.$on("submit-feedback", submitFeedback);

		function submitFeedback() {
			if ($ctrl.done.policyNumber != null && $ctrl.smartLink != null) {
				window.open($ctrl.smartLink, "_blank");
			} else {
				console.log("No Smartlink generated!");
			}
		}

		// TODO: fix this to not use timeout
		setTimeout(function () {
			QBE.expandCollapse.init();
		}, 1000);

		$ctrl.clear = function () {
			$scope.$broadcast("clear");
		};

		$ctrl.save = function () {
			$ctrl.title = dynamicRouter.getPageTitle();

			$ctrl.showErrorSummary = false;
			isInvalid = $scope.bikeForm.$invalid;
			if (isInvalid) {
				$scope.$broadcast("broadcast-field-errors");
				$ctrl.showErrorSummary = true;
				$scope.$broadcast("reset-field-errors");
				scrollViewTo($("#combinedValidationListing"));
				return;
			}

			getUserInput();
			$rootScope.$broadcast("open-modal", {
				modal: "saveQuote",
			});
		};

		$ctrl.back = function () {
			gtmService.trackEvent("back");
			$scope.$root.$broadcast("hide-top-banner");
			$scope.$broadcast("reset-field-errors");
			var backState = dynamicRouter.back();
			if (backState) $state.go(backState);
			else {
				var formData = getUserInput();
				if (formData.rapidEstimateUrl)
					window.location.href = formData.rapidEstimateUrl;
			}
		};

		$ctrl.moveToStep = function (step) {
			$state.go(dynamicRouter.getState(step));
		};
		$ctrl.moveToPage = function (page) {
			$state.go(page);
		};
	},
]);
